// basic-feature-panel
import BasicAdaptionImage from '../assets/images/cy/basic/basic-adaption.png'
import BasicCommentImage from '../assets/images/cy/basic/basic-comment.png'
import BasicInstallImage from '../assets/images/cy/basic/basic-install.png'
import BasicMessageImage from '../assets/images/cy/basic/basic-message.png'
import BasicSkinImage from '../assets/images/cy/basic/basic-skin.png'
import BasicStatisticImage from '../assets/images/cy/basic/basic-statistic.png'

// laboratory-panel
import LabBarrerImage from '../assets/images/cy/laboratory/cy-lab-barrer.png'
import LabDebateImage from '../assets/images/cy/laboratory/cy-lab-debate.png'
import LabEmojiImage from '../assets/images/cy/laboratory/cy-lab-emoji.png'
import LabHotImage from '../assets/images/cy/laboratory/cy-lab-hot.png'
import LabRewardImage from '../assets/images/cy/laboratory/cy-lab-reward.png'
import LabVoteImage from '../assets/images/cy/laboratory/cy-lab-vote.png'

// practice-laboratory
import PraDebateImage from '../assets/images/cy/practice/pra-emoji.png'
import PraHotCommentImage from '../assets/images/cy/practice/pra-hot-comment.png'
import PraVoteImage from '../assets/images/cy/practice/pra-vote.png'
import PraHotUsersImage from '../assets/images/cy/practice/pra-hot-users.png'
import PraNewsImage from '../assets/images/cy/practice/pra-news.png'
import PraNewsWallImage from '../assets/images/cy/practice/pra-news-wall.png'
import PraPictureImage from '../assets/images/cy/practice/pra-picture.png'
import PraPictureBarrerImage from '../assets/images/cy/practice/pra-picture-barrer.png'
import PraEmojiImage from '../assets/images/cy/practice/pra-emoji.png'
import PraRewardImage from '../assets/images/cy/practice/pra-reward.png'
import PraVideoImage from '../assets/images/cy/practice/pra-video.png'
import PraQingImage from '../assets/images/cy/practice/pra-qing.png'
import {AdvancedLinkProp} from "../types/components";


// wap端没有后台管理，不进行注册，直接显示去PC端注册畅言应用
//export const URL_REGISTER_WAP = '//www.kuaizhan.com/v2/passport/reg'
export const URL_REGISTER_PC = `//www.kuaizhan.com/v3/passport?refer=${encodeURIComponent('//changyan.kuaizhan.com')}`

// 功能介绍的语雀文档
export const URL_YUQUE_FEATURES = 'https://www.yuque.com/docs/share/28bcc4c7-02e5-4a0c-bad2-9c1767e0d7bf?# 《畅言功能介绍》'
// 畅言合作伙伴
export const URL_MORE_USER_PC = '//changyan.kuaizhan.com/partner'

//export const URL_LOGOUT_WAP = '//changyan.kuaizhan.com/v2/passport/logout'
export const URL_LOGOUT_PC = '//changyan.kuaizhan.com/logout'

// 畅言帮助文文档
export const URL_STATIC_HELP = '//changyan.kuaizhan.com/static/help/'
// 畅言体验中心
export const URL_CY_HELP = '//cy-help.kuaizhan.com/'
export const URL_CY_HELP_WAP = '//cy-help.kuaizhan.com'
// 畅言体验官网页
export const URL_CY_PRACTICE = '/practice'
export const URL_CY_PRACTICE_WAP = '/practice'
// 畅言后台管理 总揽页 新版
export const URL_CY_OVERVIEW = '/v3/changyan/overview';
export const URL_CY_OVERVIEW_WAP = '/overview';
// 业务线 - PC
export const URL_CHANGYAN_VCODE = '/api/admin/vcode'
// 新版畅言管理后台（登录成功默认跳转）
export const URL_CY_ADMIN_2026 = '/admin2026/'
export const URL_FORGET_PWD = '//www.kuaizhan.com/passport/forget-pwd?refer=http://changyan.kuaizhan.com/audit/comments/TOAUDIT/1'
export const URL_CHANGYAN_LOGIN = '//www.kuaizhan.com/v3/passport/login?refer=//changyan.kuaizhan.com'
export const URL_PRACTICE = '/practice'

// 业务线 - WAP
export const WAP_HOST = navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1? 
  'm.kuaizhan.com' : 'm.kuaizhan.com'

// footer内容
//export const FOOTER_CONTENT = `Copyright 2018 Sohu.com Inc. AllRights Reserved. 云站科技 版权所有 <a href="http://changyan.kuaizhan.com/disclaimer" target="_blank" >免责声明</a> 北京云站科技有限公司 客服电话：400-106-0025`
export const FOOTER_CONTENT = {
  contentBefore: `Copyright 2018 Sohu.com Inc. AllRights Reserved. 云站科技 版权所有 `,
  linkUrl: `http://changyan.kuaizhan.com/disclaimer`,
  linkContent: '免责声明',
  contentAfter: ' 北京云站科技有限公司 客服电话：400-106-0025'
}

export const CYAN_NAV_LINKS = [
  {
    link: '/',
    title: '首页',
    outerLink: true,
    isOpenNewWindow: false,
    category: `cyan_${window.screen.width < 1024 ? 'wap' : 'pc'}_click_nav_index`,
    page:  `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_homepage`
  },
  {
    link: '/practice',
    title: '体验',
    outerLink: true,
    isOpenNewWindow: false,
    category: `cyan_${window.screen.width < 1024 ? 'wap' : 'pc'}_click_nav_practice`,
    page:  `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_homepage`
  },
  {
    link: URL_YUQUE_FEATURES,
    title: '功能介绍',
    outerLink: true,
    isOpenNewWindow: true,
    category: `cyan_${window.screen.width < 1024 ? 'wap' : 'pc'}_click_nav_features`,
    page:  `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_homepage`
  },
  {
    link: '/static/help/',
    title: '帮助文档',
    outerLink: true,
    isOpenNewWindow: true,
    category: `cyan_${window.screen.width < 1024 ? 'wap' : 'pc'}_click_nav_help`,
    page:  `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_homepage`
  },
  {
    link: '/partner',
    title: '合作伙伴',
    outerLink: true,
    isOpenNewWindow: true,
    category: `cyan_${window.screen.width < 1024 ? 'wap' : 'pc'}_click_nav_partner`,
    page:  `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_homepage`
  },
  {
    link: 'https://m.kuaizhan.com/clubpc/forums/VIk9iSUgWjLKn1do#!/topics/tags/WBgw4K6mfilDzBdu/pages/0',
    title: '站长社区',
    outerLink: true,
    isOpenNewWindow: true,
    category: `cyan_${window.screen.width < 1024 ? 'wap' : 'pc'}_click_nav_myapps`,
    page:  `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_homepage`
  },
]

export const CY_MORE_SERVICE_LINKS: AdvancedLinkProp[] = [
{
    title: '案例',
    href: '/partner',
    linkType: 'outer'
  },
  {
    title: '快站大学',
    href: `http://www.kuaizhan.com/90/3/p2649405090dde7`,
    linkType: 'outer'
  },
  {
    title: '帮助中心',
    href: '/static/help/',
    linkType: 'outer'
  }
]

export const SHOW_CONTAINER_DESCRIPTION = [
  {
    title: [
      '零门槛接入评论',
    ],
    descriptions: [
      '完全免费',
      '无广告',
      '无忧审核',
      '快速稳定',
    ],
    //imgUrl: OffcAttractFansImage,
    iconStyle: {
      color: '#3765FF'
    }
  },
]
export const BASIC_FEATURE_DESCRIPTION = [
  {
    title: [
      '基础评论',
    ],
    descriptions: [
      '评论管理',
      '多社交账号登录（微信，QQ，微博）',
    ],
    imgUrl: BasicCommentImage,
    iconStyle: {
      color: '#3765FF'
    },
    category: `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_click_basic_comment`,
    page:  `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_homepage`
  },
  {
    title: [
      '炫彩皮肤',
    ],
    descriptions: [
      '多彩皮肤',
      '丰富主题',
      '外观商务定制'
    ],
    imgUrl: BasicSkinImage,
    iconStyle: {
      color: '#FC4D5A'
    },
    category: `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_click_basic_theme`,
    page:  `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_homepage`
  },
  {
    title: [
      '简易安装',
    ],
    descriptions: [
      '一行贴入Js',
      '多CMS平台插件安装',
      '提供APP，SDK开发包'
    ],
    imgUrl: BasicInstallImage,
    iconStyle: {
      color: '#9A43FB'
    },
    category: `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_basic_install`,
    page:  `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_homepage`
  },
  {
    title: [
      '数据统计',
    ],
    descriptions: [
      '文章阅读统计',
      '评论统计',
      '资源统计',
      '站点流量统计'
    ],
    imgUrl: BasicStatisticImage,
    iconStyle: {
      color: '#FEB900'
    },
    category: `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_basic_statistic`,
    page:  `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_homepage`
  },
  {
    title: [
      '多端适配',
    ],
    descriptions: [
      'PC',
      'WAP',
      'APP',
      '多端评论统一'
    ],
    imgUrl: BasicAdaptionImage,
    iconStyle: {
      color: '#59AB8F'
    },
    category: `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_click_basic_adaption`,
    page:  `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_homepage`
  },
  {
    title: [
      '消息推送，评论提醒',
    ],
    descriptions: [
      '邮件',
      '短信',
      '微信',
      'API推送'
    ],
    imgUrl: BasicMessageImage,
    iconStyle: {
      color: '#3765FF'
    },
    category: `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_click_basic_message`,
    page:  `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_homepage`
  }
]

export const LABORATORY_COMMENT_DESCRIPTION = [
  {
    title: [
      '辩论',
    ],
    imgUrl: LabDebateImage,
    category: `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_click_laboratory_debate`,
    page:  `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_homepage`
  },
  {
    title: [
      '投票',
    ],
    imgUrl: LabVoteImage,
    category: `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_click_laboratory_vote`,
    page:  `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_homepage`
  },
  {
    title: [
      '打赏',
    ],
    imgUrl: LabRewardImage,
    category: `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_click_laboratory_reward`,
    page:  `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_homepage`
  },
  {
    title: [
      '弹幕',
    ],
    imgUrl: LabBarrerImage,
    category: `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_click_laboratory_barrer`,
    page:  `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_homepage`
  },
  {
    title: [
      '热门汇聚',
    ],
    imgUrl: LabHotImage,
    category: `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_click_laboratory_hots`,
    page:  `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_homepage`
  },
  {
    title: [
      '评论表情',
    ],
    imgUrl: LabEmojiImage,
    category: `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_click_laboratory_emoji`,
    page:  `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_homepage`
  },
]

export const PRACTICE_LABORATORY_DESCRIPTION = [
  {
    title: [
      '畅言互动【视频弹幕】',
    ],
    imgUrl: PraVideoImage,
    url: 'article/12',
    category: `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_click_practice_video`,
    page:  `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_practice_page`
  },
  {
    title: [
      '畅言互动【图片弹幕】',
    ],
    imgUrl: PraPictureBarrerImage,
    url: 'article/11',
    category: `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_click_practice_barrer`,
    page:  `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_practice_page`
  },
  {
    title: [
      '畅言互动【打赏】',
    ],
    imgUrl: PraRewardImage,
    url: 'article/10',
    category: `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_click_practice_reward`,
    page:  `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_practice_page`
  },
  {
    title: [
      '畅言互动【新闻墙】',
    ],
    imgUrl: PraNewsWallImage,
    url: 'article/9',
    category: `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_click_practice_newswall`,
    page:  `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_practice_page`
  },
  {
    title: [
      '畅言互动【投票】',
    ],
    imgUrl: PraVoteImage,
    url: 'article/8',
    category: `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_click_practice_vote`,
    page:  `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_practice_page`
  },
  {
    title: [
      '畅言互动【辩论】',
    ],
    imgUrl: PraDebateImage,
    url: 'article/7',
    category: `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_click_practice_debate`,
    page:  `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_practice_page`
  },
  {
    title: [
      '畅言互动【轻评论】',
    ],
    imgUrl: PraQingImage,
    url: 'article/6',
    category: `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_click_practice_qing`,
    page:  `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_practice_page`
  },
  {
    title: [
      '畅言互动【评论表情】',
    ],
    imgUrl: PraEmojiImage,
    url: 'article/5',
    category: `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_click_practice_emoji`,
    page:  `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_practice_page`
  },
  {
    title: [
      '畅言互动【热文配图】',
    ],
    imgUrl: PraPictureImage,
    url: 'article/4',
    category: `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_click_practice_picture`,
    page:  `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_practice_page`
  },
  {
    title: [
      '畅言互动【热评用户】',
    ],
    imgUrl: PraHotUsersImage,
    url: 'article/3',
    category: `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_click_practice_hot-users`,
    page:  `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_practice_page`
  },
  {
    title: [
      '畅言互动【热门评论】',
    ],
    imgUrl: PraHotCommentImage,
    url: 'article/2',
    category: `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_click_practice_hot-comment`,
    page:  `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_practice_page`
  },
  {
    title: [
      '畅言互动【热门新闻】',
    ],
    imgUrl: PraNewsImage,
    url: 'article/1',
    category: `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_click_practice_news`,
    page:  `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_practice_page`
  },
]


export const MANAGE_FEATURE_DESCRIPTION = [
  {
    title: [
      '无忧审核，四层过滤',
    ],
    descriptions: [
      '机器智能过滤',
      '官方违禁词过滤',
      '用户自定义过滤',
      '关闭单篇评论',
    ],
    // imgUrl: OffcAttractFansImage,
    iconStyle: {
      color: '#3765FF'
    },
    category: `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_click_manage_review`,
    page:  `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_homepage`
  },
  {
    title: [
      '助力内部运营',
    ],
    descriptions: [
      '评论灌水',
      '头衔特权',
      '社交媒体分享',
      '评论互动'
    ],
    // imgUrl: OffcEnhanceWxImage,
    iconStyle: {
      color: '#FC4D5A'
    },
    category: `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_click_manage_operate`,
    page:  `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_homepage`
  },
  {
    title: [
      '单点登录',
    ],
    descriptions: [
      '对接网站自身账号体系',
      '社交账号登录',
    ],
    // imgUrl: OffcRefineFanseImage,
    iconStyle: {
      color: '#9A43FB'
    },
    category: `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_click_manage_login`,
    page:  `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_homepage`
  },
  {
    title: [
      '权限控制',
    ],
    descriptions: [
      '管理员分权限支持多人审核',
    ],
    // imgUrl: OffcDataVisualizationImage,
    iconStyle: {
      color: '#59AB8F'
    },
    category: `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_click_manage_authority`,
    page:  `cy_${window.screen.width < 1024 ? 'wap' : 'pc'}_homepage`
  },
]

// 畅言埋点统计

// 详情介绍(只C端有)
export const cyanDetailStat = {
  category: 'cyan_click_detail',
  bizType: 5
}
// 在线体验(只C端有)
export const cyanPracticeOnlineStat = {
  category: 'cyan_click_practice_online',
  bizType: 5
}


export const bannerStats = [
  {
    category: 'cy_homepage_banner_default_image',
    bizType: 5
  },
  {
    category: 'cy_homepage_banner_manage_image',
    bizType: 5
  },
  {
    category: 'cy_homepage_banner_laboratory_image',
    bizType: 5
  }
]

